<template>
  <div
    class="expandable-container expcont"
    :class="{ expcont_open: l_open }"
  >
    <div class="expcont_content">
      <slot
        :open="l_open"
        :swp_events="swp_events"
        :methods="{ toggle }"
      />
    </div>
  </div>
</template>

<script>
import swipe_mix from '@/mixins/swipe_mix'

export default {
  name: 'ExpandableContainer',
  mixins: [swipe_mix],
  props: {
    open: Boolean,
    close: Boolean,
    ignoreSwipeHorizontal: Boolean,
    ignoreSwipeVertical: Boolean,
    mustBeScrolledUpDown: Boolean,
  }, 
 emits: ['swipe:left','swipe:right','open','close'],
  data() {
    return {
      l_open: false,
    }
  },
  methods: {
    swpLeft() {
      if (this.ignoreSwipeHorizontal) return
      this.$emit('swipe:left')
    },
    swpRight() {
      if (this.ignoreSwipeHorizontal) return
      this.$emit('swipe:right')
    },
    swpUp(eventData) {
      if (this.ignoreSwipeVertical) return
      // console.log('swipedUp', eventData)
      this.l_open = true
      this.emitOpen()
    },
    swpDown(eventData) {
      if (this.ignoreSwipeVertical) return
      if (this.mustBeScrolledUpDown) {
        const startEl = eventData.e.currentTarget
        const scrolledDown = startEl.scrollTop === 0
        if (!scrolledDown) return
      }

      this.l_open = false
      this.emitOpen()
    },
    setOpen() {
      this.l_open = this.open
      this.emitOpen()
    },
    setClose() {
      this.l_open = false
      this.emitOpen()
    },
    emitOpen() {
      if (this.ignoreSwipeHorizontal) return
      if (this.l_open) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    },
    toggle() {
      this.l_open = !this.l_open
      this.emitOpen()
    },
  },

  watch: {
    open: {
      immediate: false,
      handler: 'setOpen',
    },
    close: {
      immediate: false,
      handler: 'setClose',
    },
  },
}
</script>

<style lang="scss" scoped>
.expcont {
  --exp-height: unset;
  --exp-width: 100%;

  --exp-content-height: 100%;
  --exp-content-max-height: var(--vh-3);

  position: relative;
  height: var(--exp-height);
  width: var(--exp-width);
  max-width: var(--exp-width);
  flex-shrink: 0;
  min-height: 0;
  min-width: 0;
  display: flex;
  &_content {
    // position: absolute;
    // min-height: 100%;
    // min-width: 100%;
    // max-height: var(--exp-content-max-height);
    // display: flex;
    // flex: 1;
    max-width: 100%;
    position: relative;
    max-height: var(--exp-content-height);
    width: var(--exp-content-width);
    display: flex;
    flex: 1;
    min-height: 0;
  }
}
</style>
